import { GoogleLogin } from "@react-oauth/google";
import { Button, Card, Form, Input, Row, Typography, message, Divider, Col } from "antd";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import { LoginContainer } from "../../components";
import { AppboxLanguageSelect } from "../../components";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

import HTTPClient from "../../utils/HTTPClient";

const { Text } = Typography;

export default function Login({ }) {
    const [user, setUser] = useLocalStorage("user", null);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (user) navigate("/home");
    }, []);

    /*const checkForProjectUid = () => {
        const projectUid = Cookies.get("ai_id");
        const redirectDone = Cookies.get("ai_redirect_done") === "true";
        if (projectUid && !redirectDone) {
            Cookies.set("ai_redirect_done", true);
            navigate("/pro/builder/create");
        } else {
            navigate("/pro/home");
        }
    };*/

    const submitLoginForm = (values) => {
        const { email, password } = values;
        HTTPClient.post("/auth/login", { email, password })
            .then(async (res) => {
                message.success(t("login.success"));
                let response = await HTTPClient.get("/auth/user");
                const logged_user = {
                    ...response.data.user_data,
                    wallet: response.data.wallet,
                    is_profile_complete: response.data.is_profile_complete,
                };
                setUser(logged_user);
                navigate("/home");
                //checkForProjectUid();
            })
            .catch((e) => {
                const { error_code } = e?.response?.data;
                message.error(t([`errors.${error_code}`, "login.error"]));
            });
        return;
    };

    const handleGoogleLogin = (credentialResponse) => {
        if (credentialResponse) {
            HTTPClient.post("/auth/google", credentialResponse)
                .then(async (res) => {
                    message.success(t("login.success"));
                    let response = await HTTPClient.get("/auth/user");
                    const logged_user = {
                        ...response.data.user_data,
                        wallet: response.data.wallet,
                        is_profile_complete: response.data.is_profile_complete,
                    };
                    setUser(logged_user);
                    navigate("/home");
                    //checkForProjectUid();
                })
                .catch((e) => {
                    message.error(t("login.error"));
                });
            return;
        }
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <LoginContainer>
            <Row justify="center" align="middle">
                <h1
                    style={{
                        color: "#fff",
                        font: '"Open Sans", sans-serif"',
                        letterSpacing: "-0.2px",
                        fontSize: "3rem",
                        marginBottom: "0.3em",
                        marginTop: !isLargeScreen ? "0" : "",
                        textAlign: "center",
                    }}>
                    {t("login.title")}
                </h1>
            </Row>
            

            <Row justify="center" align="middle">
                <Card
                    bodyStyle={{ padding: 0 }}
                    style={{
                        minWidth: isLargeScreen ? "26rem" : "90%",
                        padding: "2.25rem 1.75rem 1.25rem 1.75rem",
                        marginBottom: "3rem",
                    }}>
                    <Form
                        name="basic"
                        onFinish={submitLoginForm}
                        autoComplete="off"
                        style={{ padding: "0px" }}
                        validateTrigger="onSubmit">
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    type: "email",
                                    required: true,
                                    message: t("login.errors.email"),
                                },
                            ]}>
                            <Input placeholder={"Email"} style={{ height: "3rem" }} />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: t("login.errors.password") }]}>
                            <Input.Password placeholder={"Password"} style={{ height: "3rem" }} />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                htmlType="submit"
                                type="primary"
                                style={{
                                    display: "inline-block",
                                    width: "100%",
                                    height: "3.125rem",
                                    borderRadius: "1.5rem",
                                    color: "#fff",
                                    font: ' 700 0.875rem/0 "Open Sans", sans-serif',
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                }}>
                                {t("login.call_to_action")}
                            </Button>
                        </Form.Item>
                    </Form>
                    <Row justify="center" align="middle">
                        <GoogleLogin
                            onSuccess={(credentialResponse) => {
                                handleGoogleLogin(credentialResponse);
                            }}
                            onError={() => { }}
                        />
                    </Row>
                    
                    <Row justify="center" align="middle">
                        <Text
                            style={{
                                font: '"Open Sans", sans-serif"',
                                letterSpacing: "-0.2px",
                            }}>
                            <Link to={"/recover_password"} style={{ textDecoration: "none" }}>
                                {t("login.password_recovery")}{" "}
                            </Link>
                        </Text>
                    </Row>
                    <Divider style={{ marginBottom: "2px" }} />
                    <Row justify="center" align="middle">
                        <Col span={12}>
                            <Text
                                style={{
                                    font: '"Open Sans", sans-serif"',
                                    letterSpacing: "-0.2px",
                                }}>
                                <Link to={"/privacy"} target="_blank" style={{ textDecoration: "none" }}>
                                    Privacy Policy
                                </Link>
                            </Text>
                        </Col>
                        <Col span={12}>
                            <Text
                                style={{
                                    font: '"Open Sans", sans-serif"',
                                    letterSpacing: "-0.2px",
                                }}>
                                <Link to={"/terms_of_service"} target="_blank" style={{ textDecoration: "none" }}>
                                    Terms of Service
                                </Link>
                            </Text>
                        </Col>
                    </Row>
                    <Divider style={{ marginTop: "2px" }} />
                    <Row justify="center" align="middle">
                        <AppboxLanguageSelect />
                    </Row>
                </Card>
            </Row>
        </LoginContainer>
    );
}
